var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();

Tawk_API.customStyle = {
  zIndex: 1000,
  visibility: {
    desktop: {
      position: 'br', // 'br' = bottom-right, 'bl' = bottom-left
      xOffset: 40,    // horizontal offset in px
      yOffset: 120     // vertical offset from bottom in px
    },
    mobile: {
      position: 'br',
      xOffset: 20,
      yOffset: 100
    }
  }
};

(function(){
  var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.src='https://embed.tawk.to/6a153bc90dd2801c32042f2e/1jphf33nv';
  s1.charset='UTF-8';
  s1.setAttribute('crossorigin','*');
  s0.parentNode.insertBefore(s1,s0);
})();

const openChat = () => {
  Tawk_API.maximize();
};

const closeChat = () => {
  Tawk_API.minimize();
};
